import { Route, Routes, useLocation } from "react-router-dom";
import useBreakpoint from "hooks/useBreakpoint";
import PlanShipmentView from "./PlanShipmentView";
import { PLAN_SHIPMENT_PATH, PlanShipmentDrawerProvider } from "./PlanShipmentDrawerContext";
import PlanShipmentDrawerHost from "./PlanShipmentDrawerHost";
import ScheduleGroupDetails from "./ScheduleGroupDetails";
import ScheduleInvoiceEditor from "./ScheduleInvoiceEditor";
import ShippingNoteDetails from "./ShippingNoteDetails";
import AdvanceShippingNoteDetails from "./AdvanceShippingNoteDetails";
import SelectPOsToSchedule from "./SelectPOsToSchedule";
import SlotSelection from "./SlotSelection";

// Mounted at `plan-shipment/*`. Paths below are relative to that.
const detailRoutes = [
  <Route key="slot" path="purchase-orders/slot-selection" element={<SlotSelection />} />,
  <Route key="po" path="purchase-orders/:poId" element={<SelectPOsToSchedule />} />,
  <Route key="group" path="schedule-groups/:scheduleGroupId" element={<ScheduleGroupDetails />} />,
  <Route key="edit" path="schedule-groups/:scheduleGroupId/edit" element={<SelectPOsToSchedule />} />,
  <Route key="note" path="schedule-groups/:scheduleGroupId/shipping-note" element={<ShippingNoteDetails />} />,
  <Route
    key="invoices"
    path="schedule-groups/:scheduleGroupId/schedules/:scheduleId/invoices"
    element={<ScheduleInvoiceEditor />}
  />,
  <Route key="asn" path="shipping-notes/:asnId" element={<AdvanceShippingNoteDetails />} />,
];

/**
 * Mobile: list and each detail screen are separate full pages.
 * Desktop: the list stays mounted and the matched detail screen opens as a
 * right-side drawer on top of it, so the URL still reflects the open screen.
 */
const PlanShipmentRouter = () => {
  const { isMobile } = useBreakpoint();
  const { pathname } = useLocation();

  if (isMobile) {
    return (
      <Routes>
        <Route index element={<PlanShipmentView />} />
        {detailRoutes}
      </Routes>
    );
  }

  return (
    <>
      <PlanShipmentView />
      {pathname.replace(/\/+$/, "") !== PLAN_SHIPMENT_PATH ? (
        <PlanShipmentDrawerProvider>
          <PlanShipmentDrawerHost>
            <Routes>{detailRoutes}</Routes>
          </PlanShipmentDrawerHost>
        </PlanShipmentDrawerProvider>
      ) : null}
    </>
  );
};

export default PlanShipmentRouter;
